<template>
  <div>
    <ImportSteps :titles="['Upload Planilha', 'Mapear colunas', 'Validar planilha', 'Cotações', 'Resultado']" :active="active" />
    <transition :name="'import-slide-' + direction" mode="out-in">
      <div :key="active">
        <UploadSheet :fileData="fileData" :xmlData="xmlData" v-on:detectNFe="isXmlNfe = $event" v-on:upload="fileUpload" v-on:xml="xmlUpload" v-if="active === 0" v-on:next="next" :sample="true" />

        <MappingColumn :fileData="fileData" :columnData="columnData" :detectNFe="isXmlNfe" :customer="customer" :options="options" :xml="xmlData" :userType="userType"
          v-on:validate="columnValidate" v-on:xml="xmlValidate" v-if="active === 1" v-on:next="next" v-on:back="back" />

        <ValidateRows :fileData="fileDataWithOptions" :columnData="columnData" :customer="customer" :xml="xmlData" v-if="active === 2"
          v-on:next="next" v-on:back="back" v-on:create="quotationSend" :detectNFe="isXmlNfe" />

        <QuotationObject :records="quotationData" v-if="active === 3" v-on:next="next" v-on:back="back"
          v-on:create="prepostSave" />

        <ResultingPrespost :records="resultingData" @revalidate="revalidate" v-if="active === 4" v-on:reset="reset" />
      </div>
    </transition>
  </div>
</template>

<script>
import { UserService } from "@/services/users/user.services";
import ImportSteps from './ImportSteps.vue';
import MappingColumn from './prepost/MappingColumn.vue';
import QuotationObject from './prepost/QuotationObject.vue';
import ResultingPrespost from './prepost/ResultingPrespost.vue';
import UploadSheet from './prepost/UploadSheet.vue';
import ValidateRows from './prepost/ValidateRows.vue';

export default {
  name: "ImportPrepost",
  props: ["state"],
  components: {
    ImportSteps,
    UploadSheet,
    MappingColumn,
    ValidateRows,
    ResultingPrespost,
    QuotationObject
  },
  props: ["type"],
  computed: { fileDataWithOptions() {
      const vm = this;
      if (!vm.fileData || vm.fileData.length === 0) {
        return [];
      }
      if (!vm.options || Object.keys(vm.options).length === 0) {
        return vm.fileData;
      }
      return vm.fileData.map(function(record) {
        return Object.assign({}, record, vm.options);
      });
    }
  },
  methods: {
    fileUpload(data) {
      const vm = this;
      vm.fileOrigin = data;
      vm.fileData = data;
      vm.xmlData = null;
    },
    xmlUpload(response, files) {
      const vm = this;

        // Normaliza cada XML em um formato plano (tabela)
        const flattened = response.map(function(item) {
          return {
            NUMERO: item.number || "",
            SERIE: item.series || "",
            EMISSAO: item.issuedAt ? item.issuedAt.split("T")[0] : "",
            CNPJ_EMITENTE: (item.emitter && item.emitter.cnpj) ? item.emitter.cnpj : "",
            NOME_EMITENTE: (item.emitter && item.emitter.name) ? item.emitter.name : "",
            INSCR_ESTADUAL: (item.emitter && item.emitter.stateRegistration) ? item.emitter.stateRegistration : "",
            CNPJ_DESTINATARIO: (item.recipient && item.recipient.cnpj) ? item.recipient.cnpj : "",
            NOME_DESTINATARIO: (item.recipient && item.recipient.name) ? item.recipient.name : "",
            VALOR_TOTAL: (item.totals && (item.totals.total !== undefined)) ? item.totals.total : (
                        (item.total && item.total.value) ? item.total.value : ""),
            UF_DESTINO: (item.recipient && (item.recipient.uf || (item.recipient.address && item.recipient.address.uf))) 
                        ? (item.recipient.uf || item.recipient.address.uf) : "",
            // campos extras, se quiser:
            TRANSPORTADORA: (item.transport && item.transport.name) ? item.transport.name : "",
            PESO_BRUTO: (item.transport && item.transport.grossWeight) ? item.transport.grossWeight : "",
            ROW_RAW: item // opcional: guarda o objeto original para referência
          };
        });

        vm.xmlData = response;
        vm.fileData = flattened;
        vm.fileOrigin = flattened;
    },
    xmlValidate(customer, options) {
      console.log('xml', customer);
      const vm = this;
      vm.customer = customer;
      vm.options = options;
    },
    columnValidate(data, customer, fileData, options) {
      const vm = this;
      vm.columnData = data;
      vm.customer = customer;
      vm.fileData = fileData;
      vm.options = { ...options };
    },
    quotationSend(data) {
      const vm = this;
      vm.quotationData = data;
    },
    prepostSave(data) {
      const vm = this;
      vm.resultingData = data;
    },
    reset() {
      const vm = this;
      vm.columnData = [];
      if (vm.me.type === '2' || vm.me.type === '5') {
        vm.customer = vm.me.customers ? vm.me.customers.id : '';
      } else {
        vm.customer = "";
      }
      vm.fileData = [];
      vm.resultingData = [];
      vm.direction = 'back';
      vm.active = 0;
    },
    finish() {
      const vm = this;
      vm.active = 2;
    },
    next() {
      const vm = this;
      vm.direction = 'forward';
      if (vm.xmlData && (vm.userType === '2' || vm.me.type === '5') && !vm.isXmlNfe) {
        vm.active += 2;
      } else {
        vm.active++;
      }
    },
    back() {
      const vm = this;
      vm.direction = 'back';
      vm.active--;
      if (vm.active == 1) {
        vm.fileData = vm.fileOrigin;
      }
    },
    revalidate(failedNfe) {
      const vm = this;

      vm.fileData = vm.fileData.filter(item =>
        failedNfe.includes(Number(item.NUMERO))
      );
      vm.direction = 'back';
      vm.active = 2;
    },
    downloadSample() {
      window.open("/xpost/prepost-template.csv");
    },
  },
  data() {
    return {
      columnData: [],
      fileData: [],
      fileOrigin: [],
      resultingData: [],
      quotationData: [],
      xmlData: null,
      customer: '',
      userType: '2',
      me: {},
      active: 0,
      direction: 'forward',
      options: {},
      isXmlNfe: false,
    };
  },
  async created() {
    const vm = this;
    vm.me = await UserService.me().catch((error) => {
      this.$message({
        type: "error",
        message: error,
      });
    });
    vm.userType = vm.me.type;
    if (vm.me.type === '2' || vm.me.type === '5') {
      vm.customer = vm.me.customers ? vm.me.customers.id : '';
    }
  },
};
</script>
